// extracted by mini-css-extract-plugin
module.exports = {"wrap":"footer_wrap__q09wD","main":"footer_main__hDXG-"};